// extracted by css-extract-rspack-plugin
export default {"sellerImage":"_fb65c45a"};